<template>
  <div class="card content-crud">
    <div class="ibox" v-if="!$route.params.operation">
      <div class="ibox-title pb-0" style="padding: 16px; margin-bottom: -16px;">
        <div class="row">
          <div class="col-12">
            <h3>
              <router-link :to="endPoint + 'add'" class="btn btn-sm btn-primary mb-1" v-show="enableAdd"
              style="float: right; margin-top: -5px"><i class="fas fa-plus"></i> {{ newText }}</router-link>
              <router-link :to="endPoint + 'calendar'" class="btn btn-sm btn-primary mr-1 mb-1" v-show="enableCalendar"
              style="float: right; margin-top: -5px">
              <i class="fas fa-calendar"></i> Calendario
            </router-link>
            <router-link :to="endPoint + 'fluxograma'" class="btn btn-sm btn-primary mr-1 mb-1" v-show="enableFluxograma" style="float: right; margin-top: -5px">
              <i class="fas fa-code-branch"></i> Ver fluxograma
            </router-link>
            <button class="btn btn-sm btn-success mr-1 mb-1" style="float: right; margin-top: -5px" v-show="enableDownloadExcel" @click="downloadExcel()">
              <i class="fas fa-file-excel"></i> Baixar Excel
            </button>
            <button class="btn btn-sm btn-danger mr-1 mb-1" style="float: right; margin-top: -5px" v-show="enableDownloadPdf" @click="downloadPdf()">
              <i class="fas fa-file-pdf"></i> Baixar PDF
            </button>
            <slot name="header-actions"></slot>
          </h3>
        </div>
      </div>
      </div>
      <div class="ibox-content">
        <div class="block m-b-md text-right" v-if="enableAddModal">
          <button type="button" class="btn btn-success" @click="addModal">
            Adicionar {{ crudName }}
          </button>
        </div>
        <v-server-table class="text-center" style="padding: 10px" ref="table" :tableData="tableData" :name="table" :url="url"
          :columns="columns" :options="options">
          <div :slot="'filter__' + filter.name" v-for="filter in customFilters" :key="filter.name">
            <template v-if="filter.type == 'calendar'">
              <input type="date" class="form-control" :name="filter.call" :id="filter.name"
                @change="filterChange(filter.call, filter.name)" />
            </template>
          </div>
          <div class="d-flex align-items-center justify-content-center" slot="actions" slot-scope="props">
            <a v-show="enableDownload" data-toggle="tooltip" title="Download" class="btn btn-info fa fa-download"
              @click="download(props.row.file)">
            </a>
            <button v-show="enableActive" data-toggle="tooltip" :title="props.row.ativo ? 'Desativar' : 'Ativar'"
              type="button" class="btn" style="padding: 0 8px 0 0 !important;" @click="active(props.row)">
              <i :class="(props.row.ativo ? 'fas fa-toggle-on' : 'fas fa-toggle-off')"
                style="font-size: 3vh; color: #15488A" data-toggle="tooltip"
                :title="props.row.ativo ? 'Desativar' : 'Ativar'"></i>
            </button>
            <button v-show="enableReset" data-toggle="tooltip" title="Alterar Senha" class="btn btn-crud key"
              @click="resetpassword(props.row.id)">
              <i class="fas fa-key" data-toggle="tooltip" title="Resetar Senha"></i>
            </button>
            <button v-show="enableView" data-toggle="tooltip" title="Consultar" class="btn btn-crud view"
              @click="view(props.row.id)">
              <i class="fas fa-eye" data-toggle="tooltip" title="Visualizar"></i>
            </button>
            <button v-show="enableAccessItem" data-toggle="tooltip" title="Ir para" type="button"
              class="btn btn-crud access" @click="accessItem(props.row.id)">
              <i class="fas fa-share" data-toggle="tooltip" title="Ir para"></i>
            </button>
            <button v-show="enableEdit" data-toggle="tooltip" title="Editar" type="button" class="btn btn-crud edit"
              @click="edit(props.row.id)">
              <i class="fas fa-pencil-alt" data-toggle="tooltip" title="Editar"></i>
            </button>
            <a v-show="enableEditModal" @click="editModal(props.row.id)" data-toggle="tooltip" title="Editar" class="btn btn-warning fa fa-pencil"></a>
            <button v-show="enableDelete" data-toggle="tooltip" title="Deletar" type="button" class="btn btn-crud delete" @click="destroy(props, props.row, props.index)">
              <i class="far fa-trash-alt" data-toggle="tooltip" title="Excluir"></i>
            </button>
            <button v-show="enableSenhaPath" data-toggle="tooltip" title="Ver caminho da senha"
              class="btn btn-crud btn-primary key" @click="senhaPath(props.row.atendimento_id)">
              <i class="fas fa-map" data-toggle="tooltip" title="Ver caminho da senha"></i>
            </button>
            <template v-for="extra in extra">
              <button data-toggle="tooltip" :title="extra.title" :key="extra.id" :class="extra.class"
                @click="callExtra(extra.name, props, props.row, props.index)">
                <i :class="extra.icon" v-if="extra.icon.length > 0"></i>
                {{ extra.label }}
              </button>
            </template>
          </div>
          <div slot="photo" slot-scope="props">
            <img :src="props.row.photo" alt class="photo" />
          </div>
          <div slot="cover_photo" slot-scope="props">
            <img :src="props.row.cover_photo" alt class="photo" />
          </div>
          <div slot="cor" slot-scope="props">
            <div class="btn" v-bind:style="{ 'background-color': props.row.cor, 'width': '100%' }"></div>
          </div>
          <div slot="qrcode" slot-scope="props">
            <img :src="props.row.qrcode + ''" alt class="qrcode" />
            <br />
            <span class="bold">{{ props.row.qrcode_name }}</span>
          </div>
          <div slot="qrcodeid" slot-scope="props">
            <qrcode-vue class="code_crud" size="70" :value="props.row.qrcodeid ? props.row.qrcodeid + '' : props.row.id + ''
              " level="H"></qrcode-vue>
          </div>
        </v-server-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
// import BaseForm from "./BaseForm";
// import QrcodeVue from "qrcode.vue";

export default {
  data: function () {
    return {
      records: [],
      pages: [],
      tableData: [],
      model: [],
      qtd: '',
    };
  },
  props: {
    crudName: String,
    fieldStatus: String,
    status: String,
    newText: String,
    table: String,
    customFilters: Array,
    columns: Array,
    options: Object,
    endPoint: String,
    with: String,
    enableDownloadPdf: Boolean,
    enableDownloadExcel: Boolean,
    enableAdd: Boolean,
    enableCalendar: Boolean,
    enableAddModal: Boolean,
    enableEditModal: Boolean,
    enableEdit: Boolean,
    enableDelete: Boolean,
    enableView: Boolean,
    enableActive: Boolean,
    enableReset: Boolean,
    enableDownload: Boolean,
    enableSenhaPath: Boolean,
    enableAccessItem: Boolean,
    enableFluxograma: Boolean,
    extra: Array,
    dataForm: Object,
    // Filtros extras que não vêm do filtro por coluna da tabela (ex: um
    // calendário customizado), mesclados na exportação de Excel.
    extraExcelParams: Object,
  },
  mounted() {
    this.enableAddModal = this.enableAddModal || false;
    this.enableCalendar = this.enableCalendar || false;
    this.enableEditModal = this.enableEditModal || false;
  },
  computed: {
    url() {
      this.counter();

      return (
        this.$store.getters.api + this.endPoint + (this.with ? this.with : "")
      );
    },
  },
  methods: {
    counter() {
      // const self = this;

      // setTimeout(function () {
      //   self.qtd = self.$refs.table.data.length.toString();

      //   return self.qtd;
      // }, 5000);
    },
    filterChange(call, date) {
      let valor = $("#" + date).val();
      valor = valor.replace("T", " ");

      this.$emit(call, valor);
      this.$refs.table.refresh();
    },
    callExtra(name, props, row, index) {
      this.$emit(name, {
        props,
        row,
        index,
      });
    },
    accessItem(id) {
      let routeData = '';
      switch (this.endPoint) {
        case ("paineis/"):
          routeData = this.$router.resolve("painel/" + id);
          window.open(routeData.href, '_blank');
          break;
        case ("totens/"):
          routeData = this.$router.resolve("totem/" + id);
          window.open(routeData.href, '_blank');
          break;
      }
    },
    fluxograma() {
      this.$router.push({
        path: this.endPoint + "fluxograma",
      });
    },
    edit(id) {
      this.$router.push({
        path: this.endPoint + "edit/" + id,
      });
    },
    active(item) {
      const self = this;

      item._method = "PUT";
      item.base_centralizada = 0;
      item.model = this.url.split('/')[5];

      let url = this.url.split('/')[0] + "/" + this.url.split('/')[1] + "/" + this.url.split('/')[2] + "/" + this.url.split('/')[3] + "/" + this.url.split('/')[4];
      
      if (item.ativo) {
        item.ativo = 0;

        return axios.post(url + "/inactive/" + item.id, item);
      }

      item.ativo = 1;

      return axios.post(url + "/active/" + item.id, item);
    },
    senhaPath(id) {
      this.$router.push("/senhas/path/" + id);
    },
    resetpassword(id) {
      this.$router.push({
        path: this.endPoint + "reset-password/" + id,
      });
    },
    view(id) {
      this.$router.push({
        path: this.endPoint + "view/" + id,
      });
    },
    download(file) {
      window.open(file, "_blank");
    },
    downloadPdf() {
      window.open(`${this.$store.state.url}pdf/${this.endPoint}`, "_blank");
    },
    downloadExcel (){
      // Exporta respeitando os mesmos filtros aplicados na tela: os filtros
      // por coluna da própria tabela, mais qualquer filtro extra (ex:
      // calendário) que o componente pai informe via extraExcelParams.
      const params = new URLSearchParams();
      const tableQuery = (this.$refs.table && this.$refs.table.query) || {};
      const extra = this.extraExcelParams || {};

      Object.keys(tableQuery).forEach((key) => {
        if (tableQuery[key] !== null && tableQuery[key] !== undefined && tableQuery[key] !== "") {
          params.append(key, tableQuery[key]);
        }
      });
      Object.keys(extra).forEach((key) => {
        if (extra[key] !== null && extra[key] !== undefined && extra[key] !== "") {
          params.append(key, extra[key]);
        }
      });

      const queryString = params.toString();
      window.open(`${this.$store.state.url}excel/${this.endPoint}${queryString ? "?" + queryString : ""}`, "_blank");
    },
    destroy(props, row, index) {
      const self = this;

      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;

          case "confirm":
            axios
              .delete(this.url + row.id, {
                id: row.id,
              })
              .then((response) => {
                self.$refs.table.data.splice(index - 1, 1);
                swal("Sucesso", "Registro excluído com sucesso!", "success");
              })
              .catch((error) => {
                swal(
                  "Erro",
                  "Este registro não pode ser deletado, pois já está sendo utilizado no sistema!",
                  "error"
                );
              });
            break;
        }
      });
    },
    addModal: function () {
      this.$emit("addModal");
    },
    editModal: function (id) {
      this.$emit("editModal", id);
    },
  },
  components: {
    Pagination,
  },
};
</script>

<style scoped>
.photo {
  max-height: 90px;
  max-width: 90px;
}

.edit {
  border: 2px solid #28a745;
}

.delete {
  border: 2px solid #bb0009;
}

.key {
  border: 2px solid #ff7301;
}

.key:hover {
  background: #ff7301;
  color: white;
}

.access {
  border: 2px solid #7f51ff;
}

.access:hover {
  background: #7f51ff;
  color: white
}

table>thead>tr>th:nth-last-of-type(1) {
  width: 10% !important;
}

table>thead>tr>th:nth-of-type(1),
table>tbody>tr>td:nth-of-type(1) {
  text-align: center;
  width: 6% !important;
}
</style>
